<template>
    <div v-if='!bean.loading' class='screenContent' >
        <div class='row' id='animationsScreen' >
            <p v-if='bean.videosData.title' class='text-center'>
                {{ bean.videosData.title }}
            </p>
            <div class='col-sm-6 text-center' v-for='list in bean.videosData.list' :style='"background-color: #" + list.color' >
                <h1>
                    {{list.title}}
                </h1>
                <div v-for='video in list.videos'>
                    <div v-if='video.src'>
                        <video class='fullWidth' :poster='[bean.urlData, bean.videosData.path, list.path, video.image].join("/")' :loop='video.loop' :autoplay='video.loop' controls >
                                <source :src='[bean.urlData, bean.videosData.path, list.path, video.src].join("/")' type='video/mp4'>
                                No es posible reproducir el video
                        </video>
                    </div>
                    <img v-else class='fullWidth' :src='[bean.urlData, bean.videosData.path, list.path, video.image].join("/")' ></img>
                    <p v-html='video.description'/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SiteBean from '@/scripts/SiteBean.js';

    export default {
        data() {
            return {
                bean: SiteBean.getInstance()
            };
        }
    }

</script>
<style></style>
